module.exports = __webpack_public_path__ + "img/especial_a_lo_macho.254d8ae9.jpg";